import { FETCH_USERS, FETCH_MESSAGES, NO_MESSAGES, SELECT_USER, NEW_MESSAGE, SEND_MESSAGE } from '../../_actions/types';
import firebaseApp from '../../firebase/firebase';

export const loadUsersFromFirebase = () => {
  return dispatch => {
    firebaseApp.database().ref('users').on('value', snapshot => {
      const values = snapshot.val();
      if (values) {
        const users = {}
        for (const user of Object.values(values)) {
          users[user.meta.email] = user.meta.id
        }
        dispatch({ type: FETCH_USERS, payload: users })
      }
    });
  }
}

export const selectUser = (senderID,recipientID) => {
  return dispatch => {
    firebaseApp.database().ref(`messages/${senderID}${recipientID}`).on('value', snapshot => {
      const values = snapshot.val()
      const messages = []
      if (values){
        Object.values(values).map((message) => {
          return (
            messages.push(message[0])
          )
        })
        dispatch({ type: FETCH_MESSAGES, messages, recipient: recipientID })
      } else {
        dispatch({ type: NO_MESSAGES, payload: [], recipient: recipientID })
      }
    })
  }
}

export const sendMessage = (message, senderID, recipientID) => {
  return dispatch => {
    const Ref = firebaseApp.database().ref(`messages/${senderID}${recipientID}`).push();
    const Key = Ref.key;
    const updates = {};
    const now = new Date();
    const now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
    const chatMessage = [
      {
        _id: `_${Math.random().toString(36).substr(2, 9)}`,
        text: message,
        createAt: now_utc,
        user:{
          _id: senderID,
        }
      }
    ]
    updates[`messages/${senderID}${recipientID}/${Key}`] = chatMessage;
    updates[`messages/${recipientID}${senderID}/${Key}`] = chatMessage;
    updates[`users/${senderID}/messages/${senderID}${recipientID}`] = true;
    updates[`users/${recipientID}/messages/${recipientID}${senderID}`] = true;
    firebaseApp.database().ref().update(updates);
    dispatch({ type: SEND_MESSAGE})
  }
}



// WEBPACK FOOTER //
// ./src/components/messenger/messenger_actions.js